export default __webpack_public_path__ + "static/media/asettlement.2b7aa3a4.svg";